import React from "react";
import moment from "moment";

interface TimeRendererProp
{
    value: string;
}

class TimeRenderer extends React.Component<TimeRendererProp>
{
    static defaultProps = {};
    render(): React.ReactNode
    {
        const date = moment.utc(this.props.value).toDate();

        return <b>{
            moment(date).format("HH:mm")
        }</b>;
    }
}

export default TimeRenderer;